var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"head"},[_c('img',{staticClass:"top-logo",attrs:{"src":require("@/assets/image/login/head.png")}}),_c('div',{staticClass:"top-right"})])
}]

export { render, staticRenderFns }